export default [{
    name: 'protocol/declare',
    path: '/protocol/declare',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/protocols/collection-declaration.vue')
}, {
    name: 'protocol/declare2',
    path: '/protocol/declare2',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/protocols/collection-declaration2.vue')
}, {
    name: 'protocol/certificate',
    path: '/protocol/certificate',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/protocols/authorization-certificate.vue')
}, {
    name: 'protocol/register',
    path: '/protocol/register',
    component: () => import('@/view/protocols/register.vue')
}, {
    name: 'protocol/privacy',
    path: '/protocol/privacy',
    component: () => import('@/view/protocols/privacy.vue')
}, {
    name: 'protocol/repayment',
    path: '/protocol/repayment',
    component: () => import('@/view/protocols/repay-service.vue')
}, {
    name: 'protocol/extension',
    path: '/protocol/extension',
    component: () => import('@/view/protocols/loan-extension.vue')
}, {
    name: 'protocol/extension/service',
    path: '/protocol/extension/service',
    component: () => import('@/view/protocols/loan-extension-service.vue')
}, {
    name: 'protocol/creditquotaservice',
    path: '/protocol/creditquotaservice',
    component: () => import('@/view/protocols/credit-quota-service.vue')
}, {
    name: 'protocol/personal/credit/authorization',
    path: '/protocol/personal/credit/authorization',
    component: () => import('@/view/protocols/personal-credit-authorization.vue')
}, {
    name: 'protocol/geex/sign/contract',
    path: '/protocol/geex/sign/contract',
    component: () => import('@/view/protocols/geex-sign-contract.vue')
}, {
    name: 'protocol/geex/sign/jujian',
    path: '/protocol/geex/sign/jujian',
    component: () => import('@/view/protocols/geex-sign-jujian.vue')
}, {
    name: 'protocol/geex/vendor/zhengxin',
    path: '/protocol/geex/vendor/zhengxin',
    component: () => import('@/view/protocols/geex-vendor-zhengxin.vue')
}, {
    name: 'protocol/geex/bank/shouquan',
    path: '/protocol/geex/bank/shouquan',
    component: () => import('@/view/protocols/geex-bank-shouquan.vue')
}]